module.exports = __webpack_public_path__ + "img/orange-warning-circle.80e71989.svg";